import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const FAQ_CATEGORIES = [
  {
    id: 'inscription',
    label: 'Inscription & Paiement',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/></svg>
    ),
    questions: [
      {
        q: 'Comment s\'inscrire à un voyage ?',
        a: 'L\'inscription se fait en ligne via notre formulaire d\'inscription, depuis chez vous. Une fois le formulaire validé, votre Espace Adhérent s\'ouvre (e-mail ou téléphone + code reçu par e-mail) : vous y voyez votre reste à payer et réglez à distance sous 24 heures — virement (recommandé), carte bancaire, chèques-vacances papier par courrier (adresse sur demande par WhatsApp). Les espèces se règlent uniquement sur rendez-vous à la permanence. En cas de difficulté, nous vous accompagnons par WhatsApp.',
      },
      {
        q: 'Quels modes de paiement acceptez-vous ?',
        a: 'Depuis votre Espace Adhérent, à distance : virement bancaire (recommandé, instantané et sans frais), carte bancaire via HelloAsso, chèques-vacances ANCV papier par courrier (adresse postale communiquée sur demande par WhatsApp — pas de chèque bancaire par courrier), et avoir (suite à une annulation antérieure, valable 2 ans). En main propre, uniquement sur rendez-vous à la permanence (Decathlon Bron) : espèces et chèques-vacances papier. Pas de terminal carte bancaire à la permanence.',
      },
      {
        q: 'Peut-on payer en plusieurs fois ?',
        a: 'Oui, nous proposons le paiement en plusieurs fois sans frais supplémentaires. Les échéances précises dépendent de chaque voyage et sont indiquées dans le programme. En général : 20% minimum à l\'inscription, 50% à 6 mois du départ, et le solde 45 jours avant.',
      },
      {
        q: 'Qu\'est-ce que l\'adhésion annuelle ?',
        a: 'Comme dans toute structure associative, une adhésion annuelle au montant modeste est demandée. Elle est valable par foyer et contribue au fonctionnement général de l\'association.',
      },
      {
        q: 'Quand mon inscription est-elle définitive ?',
        a: 'Votre inscription devient définitive lorsque le formulaire est rempli ET qu\'un premier règlement (acompte) a été enregistré. Les deux doivent être envoyés en même temps.',
      },
    ],
  },
  {
    id: 'documents',
    label: 'Documents & Formalités',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0"/></svg>
    ),
    questions: [
      {
        q: 'Quels documents faut-il pour voyager ?',
        a: 'Cela dépend de la destination. Pour l\'Europe : passeport français valide ou carte d\'identité (même périmée de moins de 5 ans). Pour les destinations hors Europe : passeport biométrique obligatoire, valide au moins 6 mois après la date de retour. Les détails précis sont indiqués dans le programme de chaque voyage.',
      },
      {
        q: 'Faut-il un visa ?',
        a: 'Cela dépend de votre destination et de votre nationalité. Pour certaines destinations comme les USA, une autorisation ESTA est nécessaire. Nous vous guidons pas à pas pour toutes ces démarches, principalement via WhatsApp.',
      },
      {
        q: 'Mon enfant voyage avec moi, quels documents faut-il ?',
        a: 'Si l\'enfant ne porte pas le même nom que vous, prenez le livret de famille. Si le mineur ne voyage pas avec ses parents, une autorisation de sortie du territoire est obligatoire (formulaire officiel).',
      },
      {
        q: 'Vous aidez pour les formalités administratives ?',
        a: 'Oui ! Nous vous accompagnons pour vérifier la validité de vos documents, comprendre les visas nécessaires, remplir les formulaires en ligne ensemble, et repérer les recommandations sanitaires. Tout se fait principalement par WhatsApp, pas à pas.',
      },
    ],
  },
  {
    id: 'bagages',
    label: 'Bagages',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"/></svg>
    ),
    questions: [
      {
        q: 'Quel poids est autorisé en soute et en cabine ?',
        a: 'Les franchises bagages varient selon la compagnie aérienne et le voyage. Les limites exactes (poids en soute, poids en cabine, dimensions) sont indiquées dans le programme détaillé de chaque voyage. Consultez-le attentivement et respectez impérativement les limites indiquées. Un dépassement de poids peut entraîner des frais importants à l\'aéroport.',
      },
      {
        q: 'Quelles sont les dimensions du bagage à main ?',
        a: 'Les dimensions autorisées dépendent de la compagnie aérienne et sont précisées dans votre programme de voyage. En général, comptez environ 55 cm de longueur. Respectez bien ces dimensions, sinon votre bagage pourrait être placé en soute contre paiement à l\'aéroport. Privilégiez un bagage à roulettes pour plus de confort.',
      },
      {
        q: 'Comment bien préparer ses bagages ?',
        a: 'Nos conseils : ne surchargez pas à l\'aller (gardez de la marge pour le retour), mettez vos médicaments et un change de secours dans le bagage à main en cas de retard de livraison de votre valise, étiquetez chaque bagage (nom, prénom, adresse hôtel) et ajoutez un signe distinctif (foulard, ruban). Prenez une photo de vos bagages avant le départ.',
      },
      {
        q: 'Les liquides sont-ils autorisés en cabine ?',
        a: 'Les liquides sont interdits en cabine au-delà de 100 ml par contenant (eau, gel douche, parfum, dentifrice...). Mettez-les dans votre bagage en soute. En revanche, vous pouvez emporter de la nourriture (sandwichs, confiseries) dans le bagage à main.',
      },
    ],
  },
  {
    id: 'assurance',
    label: 'Assurance',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/></svg>
    ),
    questions: [
      {
        q: 'L\'assurance voyage est-elle obligatoire ?',
        a: 'L\'assurance n\'est pas obligatoire mais fortement recommandée. Si vous ne souscrivez pas la nôtre (en partenariat avec Groupama), nous vous conseillons vivement d\'en prendre une de votre côté. Sans assurance, les frais médicaux à l\'étranger peuvent être très élevés et les frais d\'annulation ne seront pas remboursés.',
      },
      {
        q: 'Que couvre l\'assurance ?',
        a: 'Notre assurance multirisque couvre l\'annulation pour raisons médicales ou événements graves, les frais médicaux à l\'étranger, le rapatriement, les bagages perdus ou volés, et l\'interruption de voyage. Attention : elle ne couvre pas les pertes de papiers, d\'argent ou de bijoux. Les conditions détaillées sont disponibles sur la page S\'inscrire.',
      },
      {
        q: 'Quand faut-il souscrire l\'assurance ?',
        a: 'L\'assurance doit être souscrite au moment de l\'inscription. Le coût est calculé en fonction du montant de votre voyage.',
      },
    ],
  },
  {
    id: 'surplace',
    label: 'Sur place',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
    ),
    questions: [
      {
        q: 'Comment communiquer sur place ?',
        a: 'Le wifi est généralement gratuit dans les hôtels, restaurants et aéroports. Le forfait Free à 19,99€ fonctionne dans la plupart de nos destinations (internet, WhatsApp, réseaux sociaux). Vous pouvez aussi acheter une carte SIM locale ou une eSIM (Airalo). Pensez à désactiver vos données mobiles dans l\'avion.',
      },
      {
        q: 'WhatsApp est-il indispensable ?',
        a: 'Oui, c\'est notre outil de communication principal ! Pendant le voyage, consultez le groupe WhatsApp chaque jour pour les informations, modifications d\'horaires ou de programme. C\'est aussi le moyen le plus rapide pour joindre les accompagnateurs.',
      },
      {
        q: 'Comment gérer l\'argent sur place ?',
        a: 'La carte bancaire est acceptée dans la plupart des destinations. Pour les retraits, privilégiez les distributeurs dans les banques et évitez les petits retraits multiples (frais). Le change peut se faire dans les bureaux de change sur place. Une banque en ligne type Revolut ou Boursorama réduit les frais. Chaque voyageur doit avoir ses propres ressources.',
      },
      {
        q: 'Les excursions sont-elles obligatoires ?',
        a: 'Non, le programme d\'excursions est toujours facultatif. Vous pouvez participer à toutes les activités proposées, à certaines seulement, ou profiter de journées libres à votre rythme. Les excursions sont réservées à l\'avance et non remboursables une fois confirmées.',
      },
      {
        q: 'Que faire en cas de problème de santé sur place ?',
        a: 'Prévenez immédiatement un accompagnateur qui vous indiquera la marche à suivre selon votre assurance. Gardez toujours vos médicaments importants avec l\'ordonnance dans votre bagage à main. Préparez une petite trousse pharmacie (pansements, désinfectant, médicaments courants).',
      },
    ],
  },
  {
    id: 'organisation',
    label: 'Organisation',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"/></svg>
    ),
    questions: [
      {
        q: 'Qui sont les accompagnateurs ?',
        a: 'Ce sont des bénévoles expérimentés, présents du départ jusqu\'au retour. Ils facilitent l\'arrivée à l\'hôtel, assurent le relais avec les prestataires et proposent un programme d\'excursions. Ce ne sont pas des guides professionnels : l\'esprit est celui de la balade conviviale, de la découverte et du partage.',
      },
      {
        q: 'Je voyage seul(e), vais-je me sentir à l\'aise ?',
        a: 'Absolument ! Beaucoup de nos voyageurs partent seuls et c\'est souvent là que naissent les plus belles amitiés. Nous veillons à l\'ambiance dans le groupe et à la bonne intégration de chacun. L\'esprit familial de l\'association fait que personne n\'est jamais isolé.',
      },
      {
        q: 'Y a-t-il des règles de vie en groupe ?',
        a: 'Nous attendons du savoir-vivre, de la discrétion, du respect et un langage correct. Rendez-vous 15 minutes avant chaque départ à la réception de l\'hôtel. Respectez les décisions du groupe et les temps de déplacement. Pendant les temps libres, soyez autonomes mais ne restez pas seuls.',
      },
      {
        q: 'D\'où partent les voyages ?',
        a: 'Pour les voyages en autocar : Saint-Étienne (devant la gare Châteaucreux), Saint-Priest (arrêts TCL derrière la mairie, Rue Joan Miro 69800) et Villeurbanne (piscine de Cusset, Avenue Marcel Cerdan 69100). Pour l\'Espagne, des récupérations sont possibles sur l\'A7/A9. Pour les voyages en avion : aéroport de Lyon Saint-Exupéry. Les horaires précis sont indiqués sur la page de chaque voyage.',
      },
      {
        q: 'Comment sont attribuées les places dans l\'autocar ?',
        a: 'Le placement n\'est plus effectué par les organisateurs : c\'est vous qui choisissez vous-même vos places, via votre lien personnel « Mon Bus » reçu après votre inscription, parmi les places disponibles au moment de votre choix — premiers arrivés, premiers servis, sous votre propre responsabilité. Aucune place ne peut être réservée par téléphone, par message ou par l\'intermédiaire des organisateurs. Si vous n\'avez pas fait votre choix avant le départ, une place vous sera attribuée automatiquement par les organisateurs : cette attribution est définitive et non négociable. Tous les détails sont dans la charte de placement autocar, accessible depuis le formulaire d\'inscription.',
      },
    ],
  },
];

const FAQItem = ({ question, answer, isOpen, onToggle, testId }) => (
  <div className="border-b border-gray-200 last:border-0" data-testid={testId}>
    <button
      onClick={onToggle}
      className="w-full flex items-center justify-between py-4 px-1 text-left hover:text-[#5BC5D4] transition-colors"
    >
      <span className="font-semibold text-[#1E3A5F] pr-4 text-sm">{question}</span>
      <svg
        className={`w-5 h-5 text-[#5BC5D4] flex-shrink-0 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
        fill="none" stroke="currentColor" viewBox="0 0 24 24"
      >
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
      </svg>
    </button>
    {isOpen && (
      <div className="pb-4 px-1 text-gray-600 text-sm leading-relaxed animate-fadeIn">
        {answer}
      </div>
    )}
  </div>
);

const FAQ = () => {
  const [activeCategory, setActiveCategory] = useState('inscription');
  const [openItems, setOpenItems] = useState({});
  // Iter 495 (Kamel) — questions publiées depuis les Consignes de l'assistant IA (Admin → Assistant IA → FAQ)
  const [recentes, setRecentes] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/faq/publiees`).then(r => r.json()).then(d => setRecentes(d.questions || [])).catch(() => {});
  }, []);
  const categories = recentes.length ? [...FAQ_CATEGORIES, {
    id: 'recentes', label: 'Vos questions récentes',
    icon: <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" /></svg>,
    questions: recentes,
  }] : FAQ_CATEGORIES;

  const toggleItem = (key) => {
    setOpenItems(prev => ({ ...prev, [key]: !prev[key] }));
  };

  const currentCategory = categories.find(c => c.id === activeCategory);

  return (
    <div className="faq-page" data-testid="faq-page">
      {/* Hero */}
      <section className="bg-gradient-to-r from-[#79c9ea] to-[#5ba8c8] text-white py-16">
        <div className="container-custom text-center">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4 uppercase tracking-wide" data-testid="faq-title">QUESTIONS FRÉQUENTES</h1>
          <p className="text-xl opacity-90 max-w-2xl mx-auto">
            Retrouvez les réponses aux questions les plus posées par nos voyageurs
          </p>
          <p className="text-sm opacity-70 mt-3 max-w-md mx-auto italic">
            Voyager, c'est bien. Voyager ensemble, c'est encore mieux.
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="section">
        <div className="container-custom">
          <div className="max-w-5xl mx-auto flex flex-col lg:flex-row gap-8">
            {/* Category Sidebar */}
            <div className="lg:w-64 flex-shrink-0">
              <div className="sticky top-24 space-y-1" data-testid="faq-categories">
                {categories.map(cat => (
                  <button
                    key={cat.id}
                    onClick={() => setActiveCategory(cat.id)}
                    data-testid={`faq-cat-${cat.id}`}
                    className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl text-left text-sm font-semibold transition-all ${
                      activeCategory === cat.id
                        ? 'bg-[#5BC5D4] text-white shadow-md'
                        : 'text-gray-600 hover:bg-gray-100'
                    }`}
                  >
                    {cat.icon}
                    {cat.label}
                  </button>
                ))}
              </div>
            </div>

            {/* Questions */}
            <div className="flex-grow">
              <div className="card p-6" data-testid="faq-questions">
                <div className="flex items-center gap-3 mb-6 pb-4 border-b-2 border-[#5BC5D4]">
                  <div className="w-10 h-10 rounded-full bg-[#5BC5D4]/10 flex items-center justify-center text-[#5BC5D4]">
                    {currentCategory?.icon}
                  </div>
                  <h2 className="text-2xl font-bold text-[#1E3A5F]">{currentCategory?.label}</h2>
                </div>
                {currentCategory?.questions.map((item, i) => (
                  <FAQItem
                    key={`${activeCategory}-${i}`}
                    question={item.q}
                    answer={item.a}
                    isOpen={!!openItems[`${activeCategory}-${i}`]}
                    onToggle={() => toggleItem(`${activeCategory}-${i}`)}
                    testId={`faq-item-${activeCategory}-${i}`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Important Baggage Notice */}
      <section className="section bg-amber-50" data-testid="baggage-notice">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto">
            <div className="card p-8 border-2 border-amber-300 bg-white">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-full bg-amber-100 flex items-center justify-center flex-shrink-0">
                  <svg className="w-6 h-6 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"/></svg>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-amber-800 mb-2">Respectez les poids bagages</h3>
                  <p className="text-gray-700 mb-3">
                    Les franchises bagages (soute et cabine) <strong>varient selon la compagnie aérienne et le voyage</strong>.
                    Les limites exactes sont toujours indiquées dans le programme détaillé de votre voyage.
                  </p>
                  <div className="bg-amber-50 rounded-xl p-4 space-y-2 text-sm">
                    <div className="flex items-start gap-2">
                      <svg className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd"/></svg>
                      <span className="text-gray-700"><strong>Ne surchargez pas à l'aller</strong> — gardez de la marge pour les souvenirs au retour</span>
                    </div>
                    <div className="flex items-start gap-2">
                      <svg className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd"/></svg>
                      <span className="text-gray-700"><strong>Pesez vos bagages avant de partir</strong> — un dépassement coûte cher à l'aéroport</span>
                    </div>
                    <div className="flex items-start gap-2">
                      <svg className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd"/></svg>
                      <span className="text-gray-700"><strong>Médicaments et change de secours</strong> toujours dans le bagage à main</span>
                    </div>
                    <div className="flex items-start gap-2">
                      <svg className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd"/></svg>
                      <span className="text-gray-700"><strong>Liquides interdits en cabine</strong> au-delà de 100 ml par contenant</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section bg-gradient-to-r from-[#25D366] to-[#128C7E] text-white">
        <div className="container-custom text-center">
          <h2 className="text-3xl font-bold mb-3">Vous n'avez pas trouvé la réponse ?</h2>
          <p className="text-lg opacity-90 mb-8">Écrivez-nous directement, nous répondons rapidement !</p>
          <div className="flex flex-wrap justify-center gap-4">
            <a href="https://wa.me/message/XTYPH2HUY3L6L1" target="_blank" rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-white text-[#25D366] px-8 py-4 rounded-xl font-bold text-lg hover:bg-gray-50 transition shadow-lg"
              data-testid="faq-whatsapp-btn"
            >
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/></svg>
              Posez votre question sur WhatsApp
            </a>
            <Link to="/conseils-pratiques" onClick={() => window.scrollTo(0, 0)}
              className="inline-flex items-center gap-2 border-2 border-white text-white px-8 py-4 rounded-xl font-bold hover:bg-white/10 transition"
            >
              Voir les conseils pratiques
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQ;
